import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { SendEgresoEmailRequest, SendEgresoEmailResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class EgresoEmailService {
  private readonly http = inject(HttpClient);

  private readonly mailingApiBaseUrl = environment.mailingApi;
  private readonly sendEgresoEmailEndpoint = `${this.mailingApiBaseUrl}/email/egresos-email`;

  sendEgresoEmail(payload: SendEgresoEmailRequest): Observable<SendEgresoEmailResponse> {
    return this.http
      .post(this.sendEgresoEmailEndpoint, payload, { responseType: 'text' })
      .pipe(
        map((message) => ({
          message,
          statusCode: 200,
        }))
      );
  }
}
